import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "border rounded p-3 mb-3 h-300" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "text-primary fw-normal" }, "Current Stimuli:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary text-light rounded-pill"
}, [
  /*#__PURE__*/_createTextVNode(" Add New Stimuli "),
  /*#__PURE__*/_createElementVNode("div", { class: "d-inline" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "px-1 ms-2" }, [
      /*#__PURE__*/_createElementVNode("i", {
        class: "fa fa-plus",
        "aria-hidden": "true"
      })
    ])
  ])
], -1)
const _hoisted_4 = { class: "table-responsive overflow-auto h-75 mt-3" }
const _hoisted_5 = { class: "table text-secondary" }
const _hoisted_6 = { class: "ps-0" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-pencil",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-o",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]


import { toast } from "vue3-toastify";
import { stimuliObject, projectObject } from "@/interfaces";
import { useProjectStimuliStore } from "@/store/ProjectStimuliStore";


const __default__ = {
  name: "CurrentStimuli",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  project: {
    type: projectObject,
    required: true,
  },
},
  setup(__props) {

const { deleteStimuli } = useProjectStimuliStore();



const deleteTheStimuli = (stimuli: stimuliObject) => {
  deleteStimuli(stimuli);
  toast.success(stimuli.type + " stimuli was deleted successfully!");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, {
      to: { name: 'CreateStimuli' },
      class: "text-secondary text-decoration-none d-flex justify-content-end"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.project.stimuli, (stimuli, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(stimuli.name), 1),
              _createElementVNode("td", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: { name: 'EditStimuli', params: { stimulId: stimuli.id } },
                  class: "btn btn-info text-light rounded-pill m-1"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (deleteTheStimuli(stimuli)),
                  class: "btn btn-primary text-light rounded-pill m-1"
                }, _hoisted_11, 8, _hoisted_9)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})